import { BaseEntity } from './shared/baseEntity';
import { BaseContactInfo } from './shared/baseContactInfo';

export const Company = ({
  companyName,
  industry,
  legalForm,
  numberOfEmployees,
  address,
  headquarter,
  branches,
  externalITProviders = [],
  executiveBoard,
  dataProtectionOfficer,
  informationSecurityOfficer,
  itResponsible,
  id,
  isActive
}) => {
  return Object.assign(
    {
      companyName,
      industry,
      legalForm,
      numberOfEmployees,
      address,
      headquarter,
      branches,
      externalITProviders,
      executiveBoard,
      dataProtectionOfficer,
      informationSecurityOfficer,
      itResponsible
    },
    BaseEntity(id, isActive)
  );
};

export const ExternalITProviders = ({
  companyName,
  firstName,
  lastName,
  phoneNumber,
  email }) => {
  return Object.assign(
    { companyName },
    BaseContactInfo({
      firstName,
      lastName,
      phoneNumber,
      email
    })
  );
}

export const ExecutiveBoard = ({
  firstName,
  lastName,
  phoneNumber,
  email }) => {
  return BaseContactInfo({
    firstName,
    lastName,
    phoneNumber,
    email
  })
}

export const DataProtectionOfficer = ({
  firstName,
  lastName,
  phoneNumber,
  email }) => {
  return BaseContactInfo({
    firstName,
    lastName,
    phoneNumber,
    email
  })
}

export const InformationSecurityOfficer = ({
  firstName,
  lastName,
  phoneNumber,
  email }) => {
  return BaseContactInfo({
    firstName,
    lastName,
    phoneNumber,
    email
  })
}

export const ITResponsible = ({
  firstName,
  lastName,
  phoneNumber,
  email }) => {
  return BaseContactInfo({
    firstName,
    lastName,
    phoneNumber,
    email
  })
}


// WEBPACK FOOTER //
// ./src/models/company.js